// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._loginFlowContainer_OSz1H {
	display: flex;
	flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./core/src/components/LoginFlow/LoginFlowContainer.vue"],"names":[],"mappings":";AAqBA;CACA,aAAA;CACA,sBAAA;AACA","sourcesContent":["<!--\n - SPDX-FileCopyrightText: 2026 Nextcloud GmbH and Nextcloud contributors\n - SPDX-License-Identifier: AGPL-3.0-or-later\n-->\n\n<script setup lang=\"ts\">\nimport NcGuestContent from '@nextcloud/vue/components/NcGuestContent'\n\ndefineProps<{\n\theading: string\n}>()\n</script>\n\n<template>\n\t<NcGuestContent class=\"picker-window\" :class=\"$style.loginFlowContainer\">\n\t\t<h2>{{ heading }}</h2>\n\t\t<slot />\n\t</NcGuestContent>\n</template>\n\n<style module>\n.loginFlowContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginFlowContainer": `_loginFlowContainer_OSz1H`
};
export default ___CSS_LOADER_EXPORT___;
